import PointSCommon, { CommonPluginOptions } from "@points/common";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import { VNode } from "vue/types/umd";
import App from "./App.vue";
import "./plugins/axios";
import vuetify from "./plugins/vuetify";
import { createRouter } from "./router";
import "./styles/app.scss";
import { globals } from "@/utilities/globals";
import DatetimePicker from "vuetify-datetime-picker";
import VueShortkey from "vue-shortkey";
import { createPinia, PiniaVuePlugin } from "pinia";
import Router from "vue-router";

Vue.config.productionTip = false;
Vue.config.devtools = !!globals.VUE_APP_DEVTOOLS;

// Register pinia
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
// Create router (depends on pinia)
Vue.use(Router);
const router = createRouter();
// Register common config/handler/components (depends on pinia and router)
Vue.use<CommonPluginOptions>(PointSCommon, {
    ...globals,
    pinia,
    router
});

Vue.use(VueShortkey);
Vue.use(VueTheMask);
Vue.use(DatetimePicker);

const {
    hostname,
    href,
    protocol
} = location;
if (hostname !== "localhost") {
    if (hostname.includes("ndtirepartner.com"))
        location.replace("https://www.tfdistro.com/b2blogin");
    const isApex = hostname.split(".")[1] === "com";
    const isHttp = protocol === "http:";
    if (isApex && isHttp)
        location.replace(href.replace("http://", "https://www."));
    else if (isApex) location.replace(href.replace("https://", "https://www."));
    else if (isHttp) location.replace(href.replace("http://", "https://"));
}

new Vue({
    pinia,
    router,
    vuetify,
    render: (h): VNode => h(App)
}).$mount("#app");
